import { DateTime } from "luxon";
import { DueDateProperty } from "src/components";
import { ActionItemDetailDto, useEditActionItemDueDate } from "src/http";

interface IProps {
  actionItem: ActionItemDetailDto;
}

const ActionItemDueDateProperty = (props: IProps) => {
  const { mutate: editDueDate, isLoading } = useEditActionItemDueDate();

  function handleSaveClicked(dueDate: DateTime | null) {
    editDueDate({
      actionItemGuid: props.actionItem.guid,
      dueDate:
        dueDate != null
          ? DateTime.fromObject({
              year: dueDate.year,
              month: dueDate.month,
              day: dueDate.day,
              hour: 23,
              minute: 59,
              second: 59,
            }).toISO({
              includeOffset: false,
            })
          : null,
      planGuid: props.actionItem.teamPlanSection.planGuid,
    });
  }

  return (
    <DueDateProperty
      dueDate={props.actionItem.dueDate}
      userCanEdit={props.actionItem.userCanEdit}
      disabled={isLoading}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { ActionItemDueDateProperty };
